import { ReactElement } from 'react';
import { DatasetDetailsPreviewContainer } from '../../../modules/datasets/containers/DatasetDetailsPreview.container';

export const DatasetDetailsPreviewView = (): ReactElement => <DatasetDetailsPreviewContainer />;
